import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CountdownTimer } from './components/CountdownTimer';
import { Products } from './components/Products';
import { Bundles } from './components/Bundles';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FAQ } from './components/FAQ';
import { Admin } from './components/Admin';
import Accessories from './components/Accessories';
import { MaintenancePage } from './components/MaintenancePage';
import { BackToTop } from './components/BackToTop';
import { ChatWidget } from './components/ChatWidget';
import { Toaster } from './components/ui/sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function LandingPage() {
  const location = useLocation();
  const [selectedTea, setSelectedTea] = useState(null);
  
  // Check if there's a tea to inquire about from navigation state
  useEffect(() => {
    if (location.state?.inquireTea) {
      setSelectedTea(location.state.inquireTea);
    }
  }, [location.state]);
  
  return (
    <>
      <AnnouncementBar />
      <Header />
      <Hero />
      <CountdownTimer />
      <Products onInquire={setSelectedTea} />
      <Bundles onInquire={setSelectedTea} />
      <Benefits />
      <Testimonials />
      <About />
      <FAQ />
      <Contact selectedTea={selectedTea} clearSelectedTea={() => setSelectedTea(null)} />
      <Footer />
      <BackToTop />
    </>
  );
}

function MainApp() {
  const [isLoading, setIsLoading] = useState(true);
  const [maintenanceMode, setMaintenanceMode] = useState(false);

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const response = await fetch(`${API_URL}/api/admin/maintenance`);
        const data = await response.json();
        setMaintenanceMode(data.enabled);
        
        // Track visit (only if not in maintenance mode)
        if (!data.enabled) {
          fetch(`${API_URL}/api/track-visit`, { method: 'POST' }).catch(() => {});
        }
      } catch (error) {
        console.error('Error checking maintenance mode:', error);
      }
      setIsLoading(false);
    };
    checkMaintenance();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#f5e9d0' }}>
        <div className="animate-pulse" style={{ color: '#5e3a1c' }}>Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={maintenanceMode ? <MaintenancePage /> : <LandingPage />} />
      <Route path="/accessories" element={<Accessories />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <MainApp />
        <ChatWidget />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
